<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        class="grid-col-1-2 grid-row-1-2"
        :root="rootNode"  
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="input-block grid-col-1-3 grid-row-2-3">
        <label>
          Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.CHECKBOX_LABEL"></tooltip>
        </label>
        <input
          type="text"
          v-model="content"
          name="content"
          required
        />
      </div>
      <div class="grid-col-1-4 grid-row-3-4">
        <slot></slot>
      </div>
      <fieldset v-if="!simpleView" class="more-option grid-col-1-4 grid-row-4-5">
        <legend>
          More Options
        </legend>
      </fieldset>
      
    </div>
  </div>
</template>

<script>
import { ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { AgreeTerms, SPECIAL_COMP_PREFILL } from "../mixins/special-component-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";

export default {
  name: "AgreeTermsModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.FIELDS,
      content: SPECIAL_COMP_PREFILL.AgreeTerms.CONTENT,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("insertNoCompType", this.fillFormData());
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
    simpleView: function() {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
  },
  mounted() {
    this.insertIntoComponentModal();
  },
  methods: {
    fillFormData: function () {
      let formData = structuredClone(AgreeTerms);
      formData.metadata.content = this.content;
      return formData;
    },
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "1 / 2";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.checkbox-block {
  align-self: center;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 0 9px 3px 9px;
  margin-top: 3px;
  cursor: pointer;
  font-weight: bolder;
}

.checkbox-input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>